import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {fromEvent, Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged, takeUntil} from 'rxjs/operators';

@Component({
  selector: 'nc-main-content',
  templateUrl: './nc-main-content.component.html',
  styleUrls: ['./nc-main-content.component.scss']
})
export class NcMainContentComponent implements OnInit, OnDestroy {
  @ViewChild('virtualViewport') public virtualViewport: ElementRef;

  protected deactivatedSubject: Subject<boolean> = new Subject<boolean>();

  ngOnInit(): void {
    fromEvent(window, 'resize')
      .pipe(
        distinctUntilChanged(),
        debounceTime(10),
        takeUntil(this.deactivatedSubject)
      ).subscribe(() => {
      (this.virtualViewport as any).checkViewportSize();
    });
  }

  ngOnDestroy(): void {
    this.deactivatedSubject.next(true);
    this.deactivatedSubject.complete();
  }
}
